import { Medscape } from '../../medscape';
import { DecisionPointShare } from './decision-point-share';
import { CommonSVPLoadModule as SVPLoader } from '../../modules/svpload/common-svp-load-module';
import { StickyVideo } from '../promos-articles/modules/common/sticky-video/sticky-video';
import { PlayListAPI } from '../promos-articles/modules/recap/filmstrip/recap-filmstrip';
import { CloseCaptionReconfig } from '../promos-articles/modules/recap/close-caption';
import { SkipIfi } from '../promos-articles/modules/recap/skip-ifi';
import { VideoSaver } from '../promos-articles/modules/save-video/save-video';
class DP_DirectIFI{
	constructor(){
		this.videoPlayed;
		this.resolvePromise = null;
		this.videoLoadedPromise = new Promise(resolve => this.resolvePromise = resolve);this. MAX_RELATED_ARTICLES = 10; // We only show 10 articles in related articles widget
		this.domain = getDomain();
		this.BASE_URL_DP_SELECTION_PATH_API = '//api.' + this.domain + 'medscape.com/' + 'contentmetadataservice/decisionpoint/ODP/type/';
		this.BASE_URL_DP_ARTICLE_API = '//api.' + this.domain + 'medscape.com/' + 'contentmetadataservice/decisionpoint/article/';
		this.filmStripCreated = false;
		this.injectIFIwithNowPlaying = false;
		window.currentArticleVideoData = {};
		this.typeUrlParam = window.location.pathname.indexOf('oncology') > -1 ? 'ctype' : 'type';
		this.subTypeUrlParam = window.location.pathname.indexOf('oncology') > -1 ? 'ttype' : 'subtype';
		this.dpShareTools = new DecisionPointShare();
		window.sticky = new StickyVideo("#cme-video-player", $("h1.title").text());
		this.ccReconfig = new CloseCaptionReconfig();
		this.playListApi = new PlayListAPI();
		this.specialityUrl = $("#dpTitleText").attr('data-url') ? $("#dpTitleText").attr('data-url') : "/oncology" ;
		this.skipIfi = new SkipIfi();
		this.isIfiFirst = false;
	}
	
	init(videoEl, vidConfigObj, tracking){
		window.currentArticleVideoData = vidConfigObj;
		if(window.sponsoredVideoData){
			this.playIFIVideo(videoEl,tracking)
		}		
		else{
			setTimeout(()=>{
				if(window.sponsoredVideoData){
					this.playIFIVideo(videoEl,tracking)
				}
				else{
					console.log("Even after 5 secs no Ad served event on the page, hence editorial video triggered."); 
					this.playEditorialVideo(videoEl, vidConfigObj, tracking)
				}
				
			},5000)
		}
	}
	addNowPlayingVideo(){
		var timeIntervals = [0, 25, 50, 75];
		var videoFinished = false;
		const articletextFull = $("title").eq(0).text();
		const articletext = this.truncateArticleTitle(articletextFull);	
		let bumperImage  =  $('#videoContent img').length > 0 ? $('#videoContent img').attr('src'):"";
		if (!bumperImage) {
			bumperImage = window.currentThumbnail;
		}
		let nowPlayingVideo =  `<div class='filmStrip-card carousel-cell current-video'>
		<div class="label playing">NOW PLAYING</div>
		<div class='video-teaser'><img alt="${articletext}" src=${bumperImage}></div>
		<div class='filmStrip-card-title'>${this.playListApi.enhanceTitleForViewability(articletext)}</div></div>`;
		if(window.sponsoredVideoData && window.sponsoredVideoData.video.videoId === "ifivideo"){
			console.log('nowplaying IFI')
			$('div.filmStrip').prepend(nowPlayingVideo + window.ifiVideoHtmlString);
			$(".current-video .label.playing").hide();
			$(".ifi-card .label.playing").show();
		}else{
			$('div.filmStrip').prepend(nowPlayingVideo);
			$(".current-video .label.playing").show();
			$(".ifi-card .label.playing").hide();
		}
		this.addVideoSaver();
		// Add event listner to current video player
		$(".current-video").on("click",  () => {
			console.log('current video clicked');
			this.closeSkip();
			if (window.currentArticleVideoData.videoId != window.myVideoPlayer.amp.media.metadata.videoId) {
				$(".current-video .label.playing").show();
				$(".ifi-card .label.playing").hide();
				window.myVideoPlayer.setMedia(window.currentArticleVideoData);
				$('.article-wrapper').show();
				const nextVideoUrl = location.origin + `${this.specialityUrl}/viewarticle/` + window.nextVideo["articleId"];
				window.sticky.setStickyTitle(articletext)
				if (window.sponsoredVideoData && window.isIFIPlayed === false)
					window.sticky.setIFIVideo(window.sponsoredVideoData["title"], ".ifi-card");
				else  {
					window.sticky.setNextVideo(nextVideoUrl , window.nextVideo["articleTitle"]);
				}
			}
			if($(".sponsored-html-content").length > 0) {
				$(".sponsored-html-content").hide();
				$(".sponsored-meta-data").hide();
			}
		});
		// Add event listener to ifi video player
		var addisibfrflmstrp = this.addIsiBeforeTheFilmStrip;
		$(".ifi-card").on("click", () => {
			console.log('IFI card clicked');
			this.closeSkip();
			if ( window.sponsoredVideoData && window.sponsoredVideoData.video.videoId != window.myVideoPlayer.amp.media.metadata.videoId) {
				$(".current-video .label.playing").hide();
				$(".ifi-card .label.playing").show();
				window.myVideoPlayer.setMedia(window.sponsoredVideoData.video);
				if (typeof window.sponsoredVideoData.video.trackingPixel == "string") {
					this.loadTrackingPixel(window.sponsoredVideoData.video.trackingPixel);
				}
				addisibfrflmstrp();
				$('.article-wrapper').hide();
				const nextVideoUrl = location.origin + `${this.specialityUrl}/viewarticle/` + window.nextVideo["articleId"];
				window.sticky.setStickyTitle(window.sponsoredVideoData,true)
				if (window.sponsoredVideoData && window.isIFIPlayed === true)
					window.sticky.setCurrentVideo(window.currentArticleVideoData.title , ".current-video");
				else  {
					window.sticky.setNextVideo(nextVideoUrl , window.nextVideo["articleTitle"]);
				}
			}
		});

		// Filmstip carousel creation
		window.EEDflkty = new Flickity( '.filmStrip', 
			{
				cellAlign: 'left',
				pageDots: false,
				draggable: false
			}
		);
		window.filmStripCreated = true;
		

		window.myVideoPlayer.amp.addEventListener("timeupdate",(_e) => {
			let {
				currentTime,
				duration
			} = _e.player;
			let timePercent = (currentTime / duration) * 100;
			if (window.myVideoPlayer.amp.media.metadata.videoId && window.sponsoredVideoData && window.sponsoredVideoData.video.videoId && window.myVideoPlayer.amp.media.metadata.videoId == window.sponsoredVideoData.video.videoId) {
				timeIntervals.forEach((element, i) => {
					if (timePercent > element) {
						timeIntervals.splice(i, 1);
						if (element == 0 && window.sponsoredVideoData.video[`trackingPixel-Start`]) {
							this.loadTrackingPixel(window.sponsoredVideoData.video[`trackingPixel-Start`]);
						}
						else if (window.sponsoredVideoData.video[`trackingPixel-${element}`]) {
							this.loadTrackingPixel(window.sponsoredVideoData.video[`trackingPixel-${element}`]);
						}
					}
				});
			}
		});
		window.myVideoPlayer.amp.addEventListener("ended", (params) => {
			this.closeSkip();
				if (window.sponsoredVideoData && !window.isIFIPlayed) {
					this.autoPlayIFIVideo();
					if (window.myVideoPlayer.amp.media.metadata.videoId && window.sponsoredVideoData &&
						window.sponsoredVideoData.video.videoId	&& window.myVideoPlayer.amp.media.metadata.videoId == window.sponsoredVideoData.video.videoId) {
						this.loadTrackingPixel(window.sponsoredVideoData.video[`trackingPixel-100`]);
						this.autoPlayNextVideo();
					}
				}
				else {
					this.autoPlayNextVideo();				
				}
		});
		if(this.isIfiFirst) {
			this.skipIfi.init(".filmStrip  .current-video");
		}
	}
	
	//  to return truncated title for the article in filmstrip
	truncateArticleTitle(articleTitle){
		if (articleTitle) {
			return articleTitle.length > 90 ? `${articleTitle.substring(0,90)}...` : articleTitle;
		}
	}
	
	// this plays IFI video if IFI exists
	playIFIVideo(videoEl,tracking){
		console.log("Playing IFI Video")
		this.isIfiFirst = true;
		var videoEl = document.getElementById('cme-video-player')
		var tracking = {"moduleName": "vidodp", "toolin": "video - odp"};
		
		this.setVideoConfig(videoEl,window.sponsoredVideoData.video,tracking);
		
		if (typeof window.sponsoredVideoData.video.trackingPixel == "string") {
			this.loadTrackingPixel(window.sponsoredVideoData.video.trackingPixel);
		}
		$('.article-wrapper').hide();
		this.addIsiBeforeTheFilmStrip();			
		let nextVideoUrl = location.origin + `${this.specialityUrl}/viewarticle/` + window.nextVideo["articleId"];
		window.isIFIPlayed = true;
		window.sticky.setStickyTitle(window.sponsoredVideoData,true, true);
		window.sticky.setCurrentVideo(window.currentArticleVideoData.title , ".current-video");
		$(".eed-skip.persistant .eed-skip-button").click(() => {
			this.closeSkip();
			$('.current-video').click();
		});
	}

	closeSkip() {
        $(".eed-skip").hide();
        const _persistant = $(".persistent-header.skip");
        if (_persistant.length > 0) {
            _persistant.removeClass("skip");
        }
    }

	// this plays edotorial video if no IFI exists
	playEditorialVideo(videoEl, vidConfigObj, tracking){
		console.log("Playing Edotorial Video")

		$(".current-video .label.playing").show();
		$(".ifi-card .label.playing").hide();
		var videoEl = document.getElementById('cme-video-player')
		var tracking = {"moduleName": "vidodp", "toolin": "video - odp"};

		this.setVideoConfig(videoEl,vidConfigObj,tracking);
		window.isIFIPlayed= false;
		$('.article-wrapper').show();
}
	
	//  to add ISI when IFI is palyed 
	addIsiBeforeTheFilmStrip(){
		if ($(".sponsored-html-content").length == 0) {
			if (window.sponsoredVideoData && window.sponsoredVideoData['html-content']) {
				const { "html-content": htmlContent, theme, title } = window.sponsoredVideoData;
				const isiHtmlContent = `<div class="sponsored-html-content">
										${htmlContent}
									</div>
									<div class="sponsored-meta-data">
										<div class="label">Information From Industry</div>
										<div class="title">${title}</div>
									</div>`;
				$("div.filmStrip").before(isiHtmlContent);
			}
		} else {
			$(".sponsored-html-content").show();
			$(".sponsored-meta-data").show();
		}
	}
	
	//  to add tracking pixel after filmtrip
	loadTrackingPixel(trackPix){
		const timestamp = new Date().getTime().toString();
		const trackPixWithTimeStamp = trackPix.replace("[timestamp]", timestamp);
		const trackImg = `<img src=${trackPixWithTimeStamp} height="1" width="1" alt="Advertisement">`;
		if (trackPix) {
			$(".filmStrip").append(trackImg);
		}
	}
	
	// Function to auto play the Next Video
	autoPlayNextVideo(){
		if(window.isIFIPlayed && window.currentArticleVideoData.videoId != window.myVideoPlayer.amp.media.metadata.videoId){
			$('.current-video').click();
		}
		else{
		let article = window.nextVideo;
		let articleId = article.length > 0 ? window.relatedArticles.indexOf(article.articleId) + 1 : window.relatedArticles[0].articleId;
		let nextVideoUrl = location.origin + `${this.specialityUrl}/viewarticle/` + articleId;
		if (articleId) window.location.href = nextVideoUrl;
		}
	}

	// Function to auto play the IFI after now playing
	autoPlayIFIVideo () {
		if(window.sponsoredVideoData && window.sponsoredVideoData.video.videoId != window.myVideoPlayer.amp.media.metadata.videoId) {
			$(".current-video .label.playing").hide();
			$(".ifi-card .label.playing").show();
			window.myVideoPlayer.setMedia(window.sponsoredVideoData.video);
			$('.article-wrapper').hide();
			this.addIsiBeforeTheFilmStrip();
			if (typeof window.sponsoredVideoData.video.trackingPixel == "string") {
				this.loadTrackingPixel(window.sponsoredVideoData.video.trackingPixel);
			}
			const nextVideoUrl = location.origin + `${this.specialityUrl}/viewarticle/` + window.nextVideo["articleId"];
			window.sticky.setStickyTitle(window.sponsoredVideoData,true)
			window.sticky.setNextVideo(nextVideoUrl , window.nextVideo["articleTitle"]);
		}
	}

	// Function to set media config
	setVideoConfig(videoEl, videocfgObj, tracking){
		let svpLoader = new SVPLoader();			
			svpLoader.loadSVPLibrary().then(res => {
				window.myVideoPlayer = new Medscape.modules.StreamingVideoPlayer(videoEl, videocfgObj, tracking);
				window.myVideoPlayer.create().then(event => {
					this.resolvePromise('video-loaded');
					this.addNowPlayingVideo();
				},error => {
					videoEl.innerHTML = `<div class="error">Sorry, the video player failed to load.</div>`;
				})
			})
	}

	addVideoSaver(){
		try {
			const el = $(".carousel-cell.current-video");
			if($(el).find('.save-icon').length === 0) {
				const videoSaver = new VideoSaver({
					isPlaylist: false,
					playlist: {
						thumbnail: $(el).find("img").attr('src'),
						title: $(el).find(".filmStrip-card-title").text()
					},
					link: location.pathname
				});
				videoSaver.init();
				if(videoSaver.saveIcon !== null) {
					$(el).append(videoSaver.saveIcon);
				}
			}
		}
		catch(err){
			console.log(err);
		}
	}

}

export  {
    DP_DirectIFI
}
